import clsx from 'clsx';

export default function Outcome({ children, className, highlight, info: InfoComponent, large, title }: OutcomeProps) {

    const containerClasses = clsx('outcome', className, {
        highlight,
        large,
    });

    return <div className={containerClasses}>
        <div className="outcome-container">
            <div className="outcome-title">
                {title}
                {InfoComponent && (
                    <InfoComponent />
                )}
            </div>
            <div className="outcome-content">{children}</div>
        </div>
    </div>;

}